import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.analysisProducts;

export default class AnalysisProducts extends Model {
  static entity = `${ name }`;

  static fields() {
    return {
      id: this.increment(),
      unique_id: this.string(''),
      type: this.string(''),
      name: this.string(''),
      dlc: this.number(2),
      temperature: this.attr(''),
    };
  }
}
